<ion-content>
  <div class="flex h-full flex-col">
    <div class="screen-container tiny-container my-auto">
      <div class="streak-container">
        <div class="streak-fire-container">
          <canvas
            #riveCanvas
            rive
            class="streak-fire mx-auto"
            loading="lazy"
            [riveFile]="'assets/images/post-activity/streak_fire.riv'"
            [artboard]="'Artboard'"
            [stateMachine]="'State Machine 1'"
            [autoplay]="true"
            (riveLoaded)="onFireRiveCanvasReady($event)"
            width="400"
            height="400"
          ></canvas>
          <div class="streak-counter transition">
            <span class="streak-counter-text inline-flex"></span>
            <span class="streak-counter-subtext inline-flex">
              <span>-</span>
              <span>{{ 'streaks.days_streak' | transloco }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="calendar-container mx-auto mb-4 flex w-full max-w-[420px] flex-col">
        <div class="rounded-t-[1rem] border border-neutral-200 p-6">
          <dojo-streak-week />
        </div>
        <div class="bottom-part relative rounded-b-[1rem] border-b border-l border-r border-neutral-200 p-6">
          <div class="text-secondary text-center">
            {{ 'streaks.practice_days' | transloco: { count: state.keepStreakDaysNumber } }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
<ng-template #right>
  <dojo-button (click)="handleNextStep()" class="w-full">{{ 'grading.review_answers' | transloco }}</dojo-button>
</ng-template>
